import { Controller } from "stimulus";
import { Formio } from "formiojs";

export default class extends Controller {
  static targets = ["editor", "preview", "title"];
  static values = {
    saveUrl: String,
    schema: Object
  };

  async connect() {
    const initialSchema = this.schemaValue?.components ? this.schemaValue : { components: [] };

    this.formRenderer = await Formio.createForm(this.previewTarget, initialSchema);
    this.formBuilder = await Formio.builder(this.editorTarget, initialSchema, {
      noDefaultSubmitButton: true,
      builder: {
        layout: {
          components: {
            table: false,
            tabs: false,
            columns: false,
            fieldset: false,
            well: false,
            content: false
          }
        },
        data: false,
        premium: false
      }
    });

    this.formBuilder.on("change", () => {
      this.formRenderer.setForm(this.formBuilder.schema);
      this.saveSchema(this.formBuilder.schema);
    });

    this.applyBuilderLayout();
  }

  applyBuilderLayout() {
    const palette = document.querySelector(".formcomponents");
    const canvas = document.querySelector(".formarea");
    if (palette) {
      palette.classList.remove("col-xs-4", "col-sm-3", "col-md-2");
      palette.classList.add("col-xs-12", "col-sm-3", "col-md-3", "col-lg-3");
    }
    if (canvas) {
      canvas.classList.remove("col-xs-8", "col-sm-9", "col-md-10");
      canvas.classList.add("col-xs-12", "col-sm-9", "col-md-9", "col-lg-9");
    }
  }

  saveSchema(schema) {
    if (this.saveTimeout) clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => this.persist(schema), 400);
  }

  persist(schema) {
    const title = this.hasTitleTarget ? this.titleTarget.value : null;
    fetch(this.saveUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      },
      body: JSON.stringify({
        prescreen_form_version: {
          form: schema,
          form_title: title
        }
      })
    });
  }
}
